import SovosProvider from './SovosProvider';
export default SovosProvider;
export { default as mosaicI18n } from '../internals/i18n/i18n';